var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EditCategory',{attrs:{"reportingCategoryId":_vm.reportingCategoryId,"slugAlreadyExists":_vm.slugAlreadyExists},on:{"editDetail":_vm.editCategory,"cancelEdit":_vm.cancelEdit,"updateSlugAlreadyExists":_vm.updateSlugAlreadyExists}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }